import React, { FC } from 'react'

import SvgAngleRight from '@Assets/SVG/AngleRight'
import Arrow from '@Components/Product/Slider/Components/Arrow'

interface Props {
  className?: string
  onClick?: (event) => void
}

const LeftArrow: FC<Props> = ({ className, onClick }) => (
  <Arrow
    angle={180}
    className={className}
    onClick={onClick}
    svg={<SvgAngleRight />}
  />
)

export default LeftArrow
